import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getNotificationsRpcContract = rpcContract({
  name: "get-notifications",
  paramsSchema: v.object({
    limit: v.optional(v.string()),
    offset: v.optional(v.string()),
  }),
  resultSchema: v.object({
    notifications: v.array(
      v.object({
        id: v.string(),
        type: v.string(),
        text: v.string(),
        metadata: v.optional(v.record(v.string(), v.unknown())),
        createdAt: v.string(),
        isRead: v.boolean(),
        readAt: v.optional(v.string()),
        creatorHandle: v.optional(v.string()),
        creatorAvatarUrl: v.optional(v.nullable(v.string())),
        creatorFirstName: v.optional(v.string()),
        creatorLastName: v.optional(v.string()),
      }),
    ),
    total: v.string(),
    unreadCount: v.string(),
  }),
});

export const markAllNotificationsReadRpcContract = rpcContract({
  name: "mark-all-notifications-read",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    success: v.boolean(),
    markedCount: v.string(),
  }),
});

export type GetNotificationsParams = v.InferOutput<typeof getNotificationsRpcContract.paramsSchema>;
export type GetNotificationsResult = v.InferOutput<typeof getNotificationsRpcContract.resultSchema>;

export type MarkAllNotificationsReadParams = v.InferOutput<typeof markAllNotificationsReadRpcContract.paramsSchema>;
export type MarkAllNotificationsReadResult = v.InferOutput<typeof markAllNotificationsReadRpcContract.resultSchema>;
